import { AtestadoPlanoInput, TipoAtestadoEnum } from 'graphql/types.generated'

import { AtestadoPlanoModel } from './AtestadosView'
import AtestadoModel from './components/model-atestado'
import { AtestadoQueryModel } from './model-atestado'

export const convertAtestadoPlanoFormToInput = (atestados: AtestadoPlanoModel): AtestadoPlanoInput => {
  const somenteNovos = atestados.atestadosRecentes?.filter((item) => !item.editingId)

  const emBranco = somenteNovos?.filter((it) => it.tipo === TipoAtestadoEnum.EM_BRANCO)
  const padrao = somenteNovos?.filter((it) => it.tipo === TipoAtestadoEnum.PADRAO)
  const licencaMaternidade = somenteNovos?.filter((it) => it.tipo === TipoAtestadoEnum.LICENCA_MATERNIDADE)

  return {
    emBranco: emBranco?.map((it) => ({
      id: it.editingId,
      descricao: it.descricao,
      assinadoDigitalmente: it.assinadoDigitalmente ?? false,
    })),
    licencaMaternidade: licencaMaternidade?.map((it) => ({
      id: it.editingId,
      descricao: it.descricao,
      cpfCns: it.cpfCns,
      naoPossui: it.naoPossui,
      assinadoDigitalmente: it.assinadoDigitalmente ?? false,
    })),
    padrao: padrao?.map((it) => ({
      id: it.editingId,
      descricao: it.descricao,
      cpfCns: it.cpfCns,
      naoPossui: it.naoPossui,
      date: it.data,
      hora: it.hora,
      cid10Id: it.cid10?.id,
      dias: it.dias,
      assinadoDigitalmente: it.assinadoDigitalmente ?? false,
    })),
  }
}

export const convertAtestadoQueryToForm = (item: AtestadoQueryModel): AtestadoModel => {
  const { id, descricao, tipo, assinadoDigitalmente } = item

  return {
    editingId: id,
    descricao,
    tipo,
    assinadoDigitalmente,
  }
}
